import { MSP_ROUTES_FALLBACK as MSP_ROUTES } from '@/modules/msp/routes/constants';

import { OTHER_ROUTES, ROUTES } from '@/router/config';

export const NavTabsMapping = {
  [ROUTES.HOME]: 'Головна',
  [ROUTES.USER.REQUESTS.ACTIVE_REQUESTS]: 'Мої запити',
  [OTHER_ROUTES.erz.WEAPON_REGISTERED]: 'Моя зброя',
  [MSP_ROUTES.SOCIAL_PROTECT]: 'Соціальний захист',
  [MSP_ROUTES.NEWS]: 'Новини',
  [ROUTES.EXTERNAL_SERVICES]: 'Інші державні послуги',
  [ROUTES.MAP]: 'Мапа',
};
